<template>
  <div class="login-content">
    <div class="qc-position-center login-card">
      <LoginCard identity="platform" />
      <div class="text-center pt-4">
        <b-link :href="cmsUrl" class="text-dark">廠商登入</b-link>
        ｜
        <b-link :href="manageUrl" class="text-dark">管理者登入</b-link>
      </div>
      <div class="text-center pt-4" style="font-size: 14px;">
        © {{ new Date().getFullYear() }} Quarter Car Part.版權所有。
        <span class="pl-2">v{{ version }}</span>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
.background {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background-color: #f2f2f2;
  // background: linear-gradient(0deg, #a3282e, #ff7950);
}
</style>

<script>
import LoginCard from "@/components/auth/Login.vue";

export default {
  name: "Manage_Login",
  components: {
    LoginCard
  },
  data() {
    return {
      manageUrl: "",
      cmsUrl: "",
      isDev: false,
      version: process.env.VUE_APP_VERSION
    };
  },
  created() {
    if (
      window.location.hostname === "localhost" ||
      window.location.hostname === "coding-it.gitlab.io"
    ) {
      this.isDev = true;
    }
    if (this.isDev) {
      this.manageUrl = "/manage/login";
      this.cmsUrl = "/cms/login";
    } else {
      this.manageUrl = process.env.VUE_APP_MANAGE_URL;
      this.cmsUrl = process.env.VUE_APP_CMS_URL;
    }
  },
  mounted() {
    document.querySelector("body").className = "";
    document.querySelector("body").classList.add(this.$style["background"]);
  }
};
</script>
